<template>
  <div class="table">
    <div class="container">
      <el-form :model="formData" :rules="rules" ref="formData" :label-position="labelPosition" label-width="150px" disabled>
        <el-row>
          <!--SSR Name-->
          <el-col :span="8">
            <el-form-item :label="$t('ssrManage.ssrName')" prop="ssrName">
              <el-input class="de-input" v-model="formData.ssrName" clearable></el-input>
            </el-form-item>
          </el-col>
          <!--SSR No.-->
          <el-col :span="8">
            <el-form-item :label="$t('ssrManage.ssrNo')" prop="ssrNo" disabled>
              <el-input class="de-input" v-model="formData.ssrNo" clearable></el-input>
            </el-form-item>
          </el-col>
          <!--Category1-->
          <el-col :span="8">
            <el-form-item :label="$t('ssrManage.category1')" prop="category1">
              <el-input class="de-input" v-model="formData.category1" clearable></el-input>
            </el-form-item>
          </el-col>
          <!--Category2-->
          <el-col :span="8">
            <el-form-item :label="$t('ssrManage.category2')" prop="category2">
              <el-input class="de-input" v-model="formData.category2" clearable></el-input>
            </el-form-item>
          </el-col>
          <!--状态-->
          <el-col :span="8">
            <el-form-item :label="'Status'">
              <el-input class="de-input" v-model="formData.status" clearable disabled></el-input>
            </el-form-item>
          </el-col>
          <!--Product Description-->
          <el-col :span="8">
            <el-form-item :label="$t('ssrManage.description')">
              <el-input class="de-input" v-model="formData.status" clearable></el-input>
            </el-form-item>
          </el-col>
          <!--创建人-->
          <el-col :span="8">
            <el-form-item :label="'Creator'">
              <el-input class="de-input" v-model="formData.createBy" clearable disabled></el-input>
            </el-form-item>
          </el-col>
          <!--Market Scope-->
          <el-col :span="8">
            <el-form-item :label="$t('ssrManage.marketScope')" prop="marketScope">
              <el-input class="de-input" v-model="formData.marketScope" clearable></el-input>
            </el-form-item>
          </el-col>
          <!--创建日期-->
          <el-col :span="8">
            <el-form-item :label="'Create Date'">
              <el-input class="de-input" v-model="formData.createDate" clearable disabled></el-input>
            </el-form-item>
          </el-col>
          <!--SSR Objective-->
          <el-col :span="8">
            <el-form-item :label="$t('ssrManage.ssrObjective')" prop="ssrObjective">
              <el-input class="de-input" v-model="formData.ssrObjective" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <span>{{$t('ssrManage.supplierList')}}</span>
      </div>
      <el-table :data="supplierList" ref="supplierList" border highlight-current-row style="margin-top:15px;">
        <el-table-column type="selection"></el-table-column>
        <!--供应商编号/邀请码-->
        <el-table-column show-overflow-tooltip prop="ssrNo" :label="$t('ssrManage.invitationCode')"></el-table-column>
        <!--供应商名称-->
        <el-table-column show-overflow-tooltip prop="ssrName" :label="$t('ssrManage.supplierName')"></el-table-column>
        <!--是否正式供应商-->
        <el-table-column show-overflow-tooltip prop="proposal" :label="$t('ssrManage.isSupplier')"></el-table-column>
        <!--联系人-->
        <el-table-column show-overflow-tooltip :label="$t('ssrManage.contacts')"></el-table-column>
        <!--邮箱-->
        <el-table-column show-overflow-tooltip :label="$t('ssrManage.email')"></el-table-column>
      </el-table>
      <div style="margin-top:15px;">{{$t('ssrManage.scheduleTitle')}}</div>
      <el-table :data="scheduleList" ref="scheduleList" border highlight-current-row style="margin-top:15px;" row-key="id" :tree-props="{children: 'children'}" default-expand-all>
        <!--Project Item-->
        <el-table-column show-overflow-tooltip prop="projectItem" :label="$t('ssrManage.projectItem')">
          <template slot-scope="scope">
            <span style="color: red;">*</span>{{scope.row.projectItem}}
          </template>
        </el-table-column>
        <!--Timeline-->
        <el-table-column show-overflow-tooltip prop="ssrName" :label="$t('ssrManage.timeline')">
          <template slot-scope="scope">
            <el-date-picker type="date" v-model="scope.row.timeline" />
          </template>
        </el-table-column>
        <!--Remark-->
        <el-table-column show-overflow-tooltip prop="proposal" :label="$t('ssrManage.remark')">
          <template slot-scope="scope">
            <el-input v-model="scope.row.icTime" clearable></el-input>
          </template>
        </el-table-column>
        <!--操作-->
        <el-table-column>
          <template slot-scope="scope">
            <el-button type="primary" @click="onDel">Delete</el-button>
            <el-button type="primary" @click="addScheduleRow(scope.row)">Add</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:15px;">
        <el-button type="primary" @click="ganttChartLoad">Gantt Chart</el-button>
      </div>
      <div style="margin-top:15px;">Information</div>
      <el-table :data="informationList" ref="informationList" border highlight-current-row style="margin-top:15px;" :show-header="false">
        <el-table-column type="selection"></el-table-column>
        <el-table-column prop="type"></el-table-column>
        <el-table-column prop="name"></el-table-column>
      </el-table>
      <div style="margin-top:15px;">Cost Breakdown</div>
      <el-table :data="costBreakdownList" ref="costBreakdownList" border highlight-current-row style="margin-top:15px;" :show-header="false">
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="type">
          <template slot-scope="scope">
            <el-select v-if="scope.row.type==='自定义'" v-model="costBreakdown">
              <el-option :key="index" v-for="(item,index) in costBreakdownOption" :label="item.type" :value="item.type"></el-option>
            </el-select>
            <span v-else>{{scope.row.type}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name">
          <i class="el-icon-top" style="font-size: 18px;"></i>
          <i class="el-icon-bottom" style="font-size: 18px;padding-left: 15px;"></i>
        </el-table-column>
        <el-table-column prop="type">
          <template slot-scope="scope">
            <el-link type="primary">Delete</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:15px;">Corresponding CQS</div>
      <el-table :data="correspondingList" ref="correspondingList" border highlight-current-row style="margin-top:15px;width: 500px;" :show-header="false">
        <el-table-column type="selection"></el-table-column>
        <el-table-column prop="name"></el-table-column>
        <el-table-column width="200">
          <template slot-scope="scope">
            <el-link type="primary">Delete</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <el-select v-model="corresponding" multiple style="width: 250px;padding-left: 48px;">
          <el-option :key="index" v-for="(item,index) in correspondingOption" :label="item.name" :value="item.name"></el-option>
        </el-select>
        <el-link type="primary">Add</el-link>
      </div>
      <div style="padding-top: 15px;">
        <el-checkbox v-model="checked">Product Spec</el-checkbox>
      </div>
      <!--底部操作按钮-->
      <el-row type="flex" justify="center" style="padding-top: 15px;">
        <el-button type="primary" @click="showIssueDialog = true">{{$t('ssrManage.announce')}}</el-button>
        <el-button type="primary" @click="saveCarrier('formData')">Save As Draft</el-button>
        <el-button type="primary" @click="routerBack">{{'Cancel'}}</el-button>
      </el-row>
    </div>
    <supplier-dialog :is-show.sync="showSupplierDialog" :create-fun="onSupplier" @hideDialog="showSupplierDialog = false" />
    <ssr-issue-dialog :is-show.sync="showIssueDialog" :create-fun="onIssue" @hideDialog="showIssueDialog = false" />
  </div>
</template>
<script>
import router from '../../../router';
import { apiService } from "@/api/ssr-manage/ssr-manage";
import { Message } from "element-ui";
import commonMethods from "@/utils/commonMethods";
import supplierDialog from "@/components/page/ssr-manage/supplier-dialog";
import ssrIssueDialog from "@/components/page/ssr-manage/ssr-issue-dialog";

export default {
  name: 'ssr-manage-add',
  extends: commonMethods,
  components: {
    supplierDialog,
    ssrIssueDialog
  },
  data() {
    return {
      formData: {
        supplierCode: '',
        supplierName: '',
        address: '',
      },
      labelPosition: 'right',
      showSupplierDialog: false,
      showIssueDialog: false,
      supplierList: [],
      scheduleList: [],
      informationList: [],
      costBreakdownList: [],
      costBreakdownOption: [],
      correspondingList: [],
      correspondingOption: [],
      corresponding: [],
      costBreakdown: null,
      rules: {
        supplierCode: [{ required: true, message: this.$t('ssrManage.carriersCodeInput'), trigger: 'blur' }],
        supplierName: [{ required: true, message: this.$t('ssrManage.carriersNameInput'), trigger: 'blur' }],
        city: [{ required: true, message: this.$t('ssrManage.carriersCityInput'), trigger: 'blur' }],
      },
    }
  },
  created() {
    this.getSupplierList()
    this.getScheduleList()
    this.getInformationList()
    this.getCostBreakdownList()
    this.getCorrespondingList()
  },
  methods: {
    getSupplierList() {
      this.supplierList = [{ ssrNo: 'aa', ssrName: '项目' }, { ssrNo: 'bb', ssrName: '项目' }]
    },
    getScheduleList() {
      this.scheduleList = [
        { projectItem: 'SSR/RFP Initiation', id: 1 },
        { projectItem: 'Supplier Submit Proposal', id: 2 },
        { projectItem: 'Recommendation', id: 3 },
        { projectItem: 'Business Case', id: 4 }]
    },
    getInformationList() {
      this.informationList = [
        { type: 'PQCP', name: 'Mandatory by tick' },
        { type: 'Cost Breakdown', name: 'Mandatory by tick' },
        { type: 'Capacity Analysis', name: 'Mandatory by tick' },
        { type: 'Volume Forecast', name: 'Upload' },
        { type: 'Logistics Capacity', name: 'Mandatory by tick' },
        { type: 'Other Format', name: 'Upload' },
        { type: '运费报价', name: 'Mandatory by tick' },
      ]
    },
    getCostBreakdownList() {
      this.costBreakdownOption = [
        { type: 'Raw Material ' },
        { type: 'Packaging' },
        { type: 'Production Cost' },
        { type: 'Labor Cost' },
        { type: 'Management Cost' },
        { type: 'Tax' },
        { type: 'Margin' },
        { type: 'Freight' },
        { type: 'Total Cost' },
      ]
      this.costBreakdownList = [
        { type: 'Raw Material ' },
        { type: 'Packaging' },
        { type: 'Production Cost' },
        { type: '自定义' },
        { type: 'Total Cost' },
      ]
    },
    getCorrespondingList() {
      this.correspondingList = [
        { name: 'Raw Material ' },
        { name: 'Packaging' },
        { name: 'Production Cost' },
        { name: 'Total Cost' },
      ]
      this.correspondingOption = [
        { name: 'Raw Material ' },
        { name: 'Packaging' },
        { name: 'Production Cost' },
        { name: 'Total Cost' },
      ]
    },
    //删除供应商清单
    delSupplier() {
      let val = this.$refs.supplierList.selection;
      const indexs = val.map(item => item.index);
      if (indexs.length > 0) {
        for (const index of indexs) {
          for (var i = 0; i < this.supplierList.length; i++) {
            if (index === this.supplierList[i].index) {
              this.supplierList.splice(i, 1);
            }
          }
        }
        this.$message({
          type: "success",
          message: 'Delete Success'
        });
      } else {
        this.$message({
          type: "error",
          message: 'Please select data!'
        });
      }
    },
    // 添加供应商
    onSupplier(data) {
      this.supplierList = this.supplierList.concat(data)
      this.showSupplierDialog = false
    },
    // Schedule of Events添加行
    addScheduleRow(data) {
      const item = [{ projectItem: 'Recommendation', id: 3 }]
      this.$set(data, 'children', item)
    },
    // 甘特图下载
    ganttChartLoad() {
      Message({ message: 'Schedule of Events填写未完成', type: "warning" });
    },
    //保存承运商主数据
    saveCarrier(formData) {
      this.$refs[formData].validate((valid) => {
        //前段验证是否通过
        if (valid) {
          updateSupplier(this.formData).then((res) => {
            //数据是否插入成功
            if (res.meta.success) {
              Message({ message: 'Save Success', type: "success" });
              this.cancel();
            } else {
              Message({ message: res.meta.msg, type: "error" });
            }
          })

        } else {
          return false;
        }
      })

    }
  }
}
</script>
<style scoped>
</style>
